
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m15.43 9.206-1.409-.052-.305 8.342 1.409.052.305-8.342Zm-4.135-.026h1.41v8.342h-1.41V9.18Zm-1.011 8.316-.306-8.342-1.409.052.306 8.342 1.409-.052Z"}}),_c('path',{attrs:{"d":"M3.611 5.702v1.41h1.47l1.165 13.245a.705.705 0 0 0 .702.643h10.08c.366 0 .67-.28.703-.643l1.165-13.245h1.493v-1.41H3.611ZM16.383 19.59h-8.79L6.495 7.112h10.986L16.383 19.59Z"}}),_c('path',{attrs:{"d":"M14.303 3H9.697c-.648 0-1.175.527-1.175 1.175v2.232h1.41V4.41h4.136v1.997h1.41V4.175c0-.648-.527-1.175-1.175-1.175Z"}})])
          )
        }
      }
    